<template>
  <div class="Ftr-Description">
    <LogotypeCapital class="Ftr-Description__logo" />
    <p class="Ftr-Description__txt">
      Сделано с <span class="Ftr-Description__heart">&#x2764;</span> для децентрализованного мира.
    </p>
    <p class="Ftr-Description__txt Ftr-Description__txt--thin">
      Кэпитал — это закрытый источник независимой аналитики и инвестиций в криптоиндустрии, одного из крупнейших русскоязычных криптосообществ — Крипто Нарния.
    </p>
    <time class="Ftr-Description__year">&copy;{{ get_currentYear }}</time>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  
  import LogotypeCapital from '@shared/UI/Logotypes/LogotypeCapital/LogotypeCapital.vue';
  
  //Получаем текущий год
  const get_currentYear = computed(()=> new Date().getFullYear());
</script>

<style scoped lang="scss">
  @import './styles';
</style>